<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CNCT" id="_idParaDest-8">1 The Ax</p>
<p class="BT1stPara">Out of the air, the ax. Somehow there was an ax and it rose and fell in a wild swath aimed at my head even as I tried to rise from my squatting position and lost my balance desperate to escape as my legs faltered beneath me and there came a hoarse pleading voice—“No! No please! No”—(was this my own choked voice, unrecognizable?)—as the ax-blade crashed and sank into the splintering desk beside my head missing my head by inches; by which time I’d fallen heavily onto the floor, a hard unyielding floor beneath the frayed Oriental carpet. I was scrambling to right myself, grabbing for the ax, desperate to seize the ax, in the blindness of desperation my hands flailing, and the voice (my own? my assailant’s?) high-pitched and hardly human-sounding—“No! <span class="CharOverride-2">Nooo</span>”—a fleeting glimpse of the assailant’s stubby fingers and dead-white ropey-muscled arms inside the flimsy sleeves of nightwear, and a grunting cry as of triumph and fury commingled; and again the terrible lifting of the ax-head, the dull sheen of the crude ax-blade, and the downward swing of Death once begun unstoppable, irretrievable plunging into a human skull as easily rent as a melon with no more protection than a thick rind, to expose the pulpy gray-matter of the brain amid a torrential gushing of arterial blood.</p>
<p class="BT">And still the voice rising disbelieving <span class="CharOverride-2">No no no no no.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook43527.vue?0340b41a